export default __webpack_public_path__ + "toon-boom-storyboard-pro.3d9c85bb.png";